export const ADD_BILLING_INFO = 'DELIVERY_BILLING_SCHEDULE_CREATE';

export const PERIOD_POLICY = {
  CALENDAR_MONTH: 'CALENDAR_MONTH',
  CUSTOM_PERIOD: 'CUSTOM_PERIOD',
};

export const PERIOD_POLICY_LABELS = {
  CALENDAR_MONTH: 'Calendar month',
  CUSTOM_PERIOD: 'Custom period',
};

export const INVOICE_DATE_BUSINESS_RULE = {
  BY_1ST_BUSINESS_DAY: 'BY_1ST_BUSINESS_DAY',
  BY_3RD_BUSINESS_DAY: 'BY_3RD_BUSINESS_DAY',
  BY_5TH_BUSINESS_DAY: 'BY_5TH_BUSINESS_DAY',
  BY_10TH_BUSINESS_DAY: 'BY_10TH_BUSINESS_DAY',
} as const;

export const INVOICE_DATE_BUSINESS_RULE_LABELS = {
  BY_1ST_BUSINESS_DAY: 'By 1st BD of month',
  BY_3RD_BUSINESS_DAY: 'By 3rd BD of month',
  BY_5TH_BUSINESS_DAY: 'By 5th BD of month',
  BY_10TH_BUSINESS_DAY: 'By 10th BD of month',
};

export const SCHEDULE_ITEM_TYPE = {
  MILESTONE: 'MILESTONE',
  CALENDAR_PERIOD: 'CALENDAR_PERIOD',
  CUSTOM_PERIOD: 'CUSTOM_PERIOD',
};

export const ERROR_MESSAGES = {
  PROJECT_ID_REQUIRED: 'Project ID is required',
  FAILED_LOAD_BILLING: 'Failed to load billing information',
  BUDGET_NOT_FOUND: 'Budget not found.',

  DUPLICATE_PERIOD_MONTH: 'Duplicate month: each calendar month should appear only once in the schedule',
  OVERLAPPING_PERIODS: 'Overlapping periods: periods should not overlap with each other',
} as const;
